export default __webpack_public_path__ + "static/media/icn_filter.7384f2c7.svg";